<script>
    import {millisecondsToHours, millisecondsToArray, pad0, setFocusTo} from "../lib/lib";
    import {createEventDispatcher} from 'svelte/internal';
    import Notifier from "../stores/notifier";

    export let duration;
    export let startAt = null;

    let startDate = '';
    let startTime = '';
    let time = null;

    let hours = '';
    let minutes = '';
    let seconds = '';

    const handleEscapeKey = event => {
        if (event.key === 'Escape') {
            closeEdit();
        }
    }

    const initStartDateTime = () => {
        [startDate, startTime] = startAt.split(' ');
        startTime = startTime.slice(0, 5);
    }

    const dispatch = createEventDispatcher();

    const onTimeChange = (event) => {
        if (time == null) {
            return;
        }

        if (!event.target.value) {
            return;
        }

        let value = event.target.value;
        let hour = '';
        let minutes = '';

        if (value.indexOf(":") > -1) {
            [hour, minutes] = value.split(":");
        } else {
            minutes = value.slice(-2);
            hour = value.slice(0, -2);
        }
        if (!hour) hour = 0;
        if (!minutes) minutes = 0;
        hour = pad0(~~hour % 24);
        minutes = pad0(~~minutes % 60);

        let now = new Date();
        let nowTime = `${pad0(now.getHours())}:${pad0(now.getMinutes())}`;
        startTime = `${hour}:${minutes}`;
        if (startTime > nowTime) {
            Notifier.showError("Η ώρα είναι πεπερασμένη!");
            return;
        }

        dispatch('change', `${startDate} ${startTime}:00`);
    }

    const openEdit = () => {
        if (time != null) {
            return;
        }
        if (!startAt) {
            return;
        }
        initStartDateTime();
        time = startTime;
        document.addEventListener('keydown', handleEscapeKey);
        setFocusTo("startTime");
    }

    const closeEdit = () => {
        time = null;
        document.removeEventListener('keydown', handleEscapeKey);
    }

    $: {
        [hours, minutes, seconds] = millisecondsToArray(duration);
    }
</script>

<div class="timer-field">
    <div class="duration" on:click="{ openEdit }">
        <span class:gray={ hours === '00' }>{ hours }:</span><span
            class:gray={ hours === '00' && minutes === '00' }>{ minutes }:</span><span
            class:gray={ hours === '00' && minutes === '00' && seconds === '00' }>{ seconds }</span>
    </div>
    {#if time}
        <div class="timer-start-time">
            Έναρξη <input type="text" class="form-control ms-2 me-2" id="startTime" value="{ time }"
                          oninput="this.value = this.value.replace(/[^0-9:]/g, '').replace(/(\..*?)\..*/g, '$1');"
                          on:change="{ onTimeChange }" on:focusout="{ closeEdit }"> (hh:mm)
        </div>
    {/if}
</div>

<style>
    .timer-field {
        position: relative;
    }

    .timer-field .duration {
        font-weight: 500;
        font-size: 1.2rem;
        letter-spacing: 0;
        text-align: center;
        text-transform: full-width;
    }

    .timer-field .duration .gray {
        color: #959595;
    }

    .timer-start-time {
        position: absolute;
        display: flex;
        align-items: center;
        right: 0;
        width: max-content;
        background: var(--dropdown-background);
        box-shadow: var(--dropdown-box-shadow);
        padding: 15px;
        z-index: 5000;
    }

    .timer-start-time .form-control {
        width: 70px;
    }
</style>